import { useAuthorizationStore } from '@/store/authorizationStore'

const getUserId = () => useAuthorizationStore().getUserId
const getWorkspaceSlug = () => useAuthorizationStore().getWorkspaceSlug

const getHeaderMetricsChannel = () => {
    const authorizationStore = useAuthorizationStore()
    const base = `carrier-updates.${getWorkspaceSlug()}`

    if (authorizationStore.isVendor) {
        const vendorId = authorizationStore.workspace?.vendor_id
        return vendorId ? `${base}.vendor.${vendorId}` : null
    }

    if (authorizationStore.isBuyer) {
        const buyerId = authorizationStore.workspace?.buyer_id
        return buyerId ? `${base}.buyer.${buyerId}` : null
    }

    return `${base}.manager`
}

export const ECHO_CHANNELS = {
    userNotifications: () => `user-notifications.${getUserId()}`,
    maintenanceMode: () => 'application.maintenance-mode',
    headerMetrics: getHeaderMetricsChannel,
}